module.exports = __webpack_public_path__ + "media/Memory of Illusion.d64ef458.mp3";